module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-9-d261ef788fadcaf206420f8e92411eb8.jpg";